export default {
  computed: {
    allowForecast() {
      return Boolean(this.$store.getters["security/loggedInUser"]?.allowForecast);
    },
  },
};
